(ns journal-app-client.views.layout
  (:require [clojure.string :as s]
            [journal-app-client.components.icon :as icon]
            [journal-app-client.utils.hooks :as hooks]
            [journal-app-client.utils.react :as react]
            [reagent.core :as r]
            [re-frame.core :as rf]
            [cljs.core.async :as async]
            [cljs.core.async.interop :refer-macros [<p!]]
            [journal-app-client.utils.css :as css]
            [journal-app-client.components.input :as input]
            [journal-app-client.components.button :as button :refer [glowing-icon-button dynamic-ul dynamic-icon-label
                                                                     dynamic-menu-label]]
            [journal-app-client.components.icon :refer [icon flag-class]]
            [journal-app-client.components.logo :refer [app-logo]]
            [journal-app-client.routes :as routes]
            [journal-app-client.components.image :as image]
            [journal-app-client.modals :as modals]
            [journal-app-client.components.container :refer [top-section]]
            [journal-app-client.utils.react :refer [use-state use-ref use-effect]]))

(defonce side-panel-active? (r/atom false))

(defonce dynamic-label-active? (r/atom false))
(defonce side-panel-focused? (r/atom nil))
(defonce dynamic-side-panel-hidden? (r/atom false))
(defonce dynamic-ul-active? (r/atom {}))

(defonce dynamic-right-side-panel-active? (r/atom {}))

(defn hamburger [& [props]]
  [:button.is-clickable.glows.hamburger
   (merge
    (when (map? props) props)
     {:type "button"
      :aria-label "Menu"
      :aria-controls "navigation"
      :style (merge {:width "3.5rem"
                     :height "3rem"
                     :margin "0.25rem"
                     "--is-clickable-drop-shadow-spread-1" "1.25em"
                     "--is-clickable-drop-shadow-color-1" "var(--blue)"
                     "--is-clickable-drop-shadow-spread-2" "0.5em"
                     "--is-clickable-drop-shadow-color-2" "var(--blue)"}
               (:style props))})
   [:span.hamburger-box
    [:span.hamburger-inner]]])

(defn delete-cross-arrow [& [props]]
  [:button.is-clickable.glows.delete-cross.delete-cross-arrow
   (merge
    (when (map? props) props)
    {:type "button"
     :aria-label "Menu"
     :aria-controls "navigation"
     :style (merge
             {:width "3.5rem"
              :height "3rem"
              :margin "0.25rem"}
             (:style props))})
   [:span.delete-cross-box
    [:span.delete-cross-inner]]])

(defn arrow-button [& [props]]
  [:button.is-clickable.glows
   (merge
     (when (map? props) (dissoc props :active?))
     {:type "button"
      :aria-expanded (if (:active? props) "true" "false")
      :aria-label "Menu"
      :aria-controls "navigation"
      :style (merge
               {:width "3.5rem"
                :height "3rem"
                :margin "0.25rem"}
               (:style props))})
   [:span.icon
    {:style {:transform (when (:active? props) "rotate(180deg)")
             :transition "transform var(--transition-duration) ease"}}
    [:i.fas.fa-arrow-right.fa-2x]]])

(defn theme-dropdown []
  (let [[active-dropdown set-active-dropdown] (react/use-state)
        ref (react/use-ref)
        dropdown-id "theme"
        position (hooks/use-position-in-view ref dropdown-id)
        active? (= active-dropdown dropdown-id)
        user-selected-theme @css/user-selected-theme]
    [:div.dropdown.is-active.is-center
     {:style {"--_offset-translate" (str position "px")}}
     [:div.dropdown-trigger
      [:button.is-clickable.glows
       {:aria-haspopup true
        :aria-controls "theme-menu"
        :title         "Theme"
        :on-click      (fn [event]
                         (.stopPropagation event)
                         (set-active-dropdown (when-not active? dropdown-id)))}
       [:span "Theme"]
       [icon/angle-down
        {:aria-hidden active?
         :active?     active?}]]]
     [:div.dropdown-menu
      {:ref   ref
       :role  "menu"
       :style {:min-width "5rem"}}
      [:div.dropdown-content.is-collapsible
       {:class (when-not active? "is-collapsed")
        :style {:max-height "10rem"}}
       [:a.dropdown-item
        {:type     "button"
         :class    (when (= user-selected-theme :dark) "is-active")
         :on-click (fn []
                     (set-active-dropdown nil)
                     (css/set-theme :dark))}
        "Dark"]
       [:a.dropdown-item
        {:type     "button"
         :class    (when (= user-selected-theme :light) "is-active")
         :on-click (fn []
                     (set-active-dropdown nil)
                     (css/set-theme :light))}
        "Light"]
       [:a.dropdown-item
        {:type     "button"
         :class    (when (= user-selected-theme :system) "is-active")
         :on-click (fn []
                     (set-active-dropdown nil)
                     (css/set-theme :system))}
        "System"]]]]))

(defn background-img-dropdown []
  (let [[active-dropdown set-active-dropdown] (react/use-state)
        ref (react/use-ref)
        dropdown-id "background-img"
        position (hooks/use-position-in-view ref dropdown-id)
        active? (= active-dropdown dropdown-id)
        month-index (image/month->image-index)
        selected-bg-image @image/background-image-selection]
    [:div.dropdown.is-active.is-center
     {:style {"--_offset-translate" (str position "px")}}
     [:div.dropdown-trigger
      [:button.is-clickable.glows
       {:aria-haspopup true
        :aria-controls (str dropdown-id "-menu")
        :title         "Background image"
        :on-click      (fn [event]
                         (.stopPropagation event)
                         (set-active-dropdown (when-not active? dropdown-id)))}
       [:span "Background image"]
       [icon/angle-down
        {:aria-hidden active?
         :active?     active?}]]]
     [:div.dropdown-menu
      {:ref   ref
       :role  "menu"
       :style {:min-width "5rem"}}
      [:div.dropdown-content.is-collapsible
       {:class (when-not active? "is-collapsed")
        :style {:max-height "12rem"}}
       [:a.dropdown-item
        {:type     "button"
         :class    (when (= selected-bg-image 1) "is-active")
         :style {:background-color (when (and (nil? selected-bg-image) (= month-index 1)) "var(--background)")}
         :on-click (fn []
                     (set-active-dropdown nil)
                     (reset! image/background-image-selection 1))}
        "Lone tree"]
       [:a.dropdown-item
        {:type     "button"
         :class    (when (= selected-bg-image 2) "is-active")
         :style {:background-color (when (and (nil? selected-bg-image) (= month-index 2)) "var(--background)")}
         :on-click (fn []
                     (set-active-dropdown nil)
                     (reset! image/background-image-selection 2))}
        "Tree on the rock"]
       [:a.dropdown-item
        {:type     "button"
         :class    (when (= selected-bg-image 3) "is-active")
         :style {:background-color (when (and (nil? selected-bg-image) (= month-index 3)) "var(--background)")}
         :on-click (fn []
                     (set-active-dropdown nil)
                     (reset! image/background-image-selection 3))}
        "Blue planet"]
       [:a.dropdown-item
        {:type     "button"
         :class    (when (= selected-bg-image 4) "is-active")
         :style {:background-color (when (and (nil? selected-bg-image) (= month-index 4)) "var(--background)")}
         :on-click (fn []
                     (set-active-dropdown nil)
                     (reset! image/background-image-selection 4))}
        "Sunset"]
       [:a.dropdown-item
        {:type     "button"
         :class    (when (nil? selected-bg-image) "is-active")
         :on-click (fn []
                     (set-active-dropdown nil)
                     (reset! image/background-image-selection nil))}
        "Let system decide"]]]]))

(defn top-nav-bar []
  (let [[state set-state] (react/use-state {})
        logo-props {:style {:width "1.5rem"
                            :animation "spin-initial-loader 2s linear infinite"}}]
    [top-section
     {:style {:margin-top      "0"
              :position        "sticky"
              :z-index         "30"
              :top             "0.75rem"
              :width           "100%"
              :min-height      "4rem"
              :display         "flex"
              :overflow        "unset"
              :justify-content "space-around"}}
     [:button.is-clickable.glows.is-rounded
      {:style {:min-width "10rem"}
       :on-click #(if (:spin-calendar? state)
                    (do (rf/dispatch [:select-view :game])
                        (set-state (assoc state :spin-calendar? false)))
                    (set-state (assoc state :spin-calendar? true)))}
      (if (:spin-calendar? state)
        [app-logo logo-props]
        "Calendar coming soon")]
     [:button.is-clickable.glows.is-rounded
      {:style {:min-width "10rem"}
       :on-click #(if (:spin-language? state)
                    (do (rf/dispatch [:select-view :hidden])
                        (set-state (assoc state :spin-language? false)))
                    (set-state (assoc state :spin-language? true)))}
      (if (:spin-language? state)
        [app-logo logo-props]
        "Language coming soon")]
     [:f> background-img-dropdown]
     [:f> theme-dropdown]]))

(defn content-view [content]
  (let [[parent-ref] (react/use-auto-animate)]
    [:div.container.is-fluid
     {:ref parent-ref
      :style {:min-height     "100svh"
              :padding-bottom "1rem"
              :position "relative"
              :z-index "1"}}
     [:f> top-nav-bar]
     content]))

(defn default [content props]
  [:div#application-wrapper.fade-in
   {:style {:background-color (if (= :hidden (first (:active-view props)))
                                (str "hsl(" (first (image/background-hsl)) ", "
                                  (second (image/background-hsl)) "%, "
                                  (/ (last (image/background-hsl)) 4) "%)")
                                (str "hsl(" (first (image/background-hsl)) ", "
                                  (second (image/background-hsl)) "%, "
                                  (last (image/background-hsl)) "%)"))
            :overflow-x       "hidden"}}
   [modals/main]
   [:f> content-view content]
   [:f> image/background-image {:style {:filter (if (= :hidden (first (:active-view props))) "brightness(0.25)" "brightness(1)")}}]])
